<template>
    <div class="video-player">
      <video controls :src="resolvedVideoUrl" class="video-element"></video>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VideoPlayer',
    props: {
      videoUrl: String
    },
    computed: {
      resolvedVideoUrl() {
        // Handle relative and absolute URLs
        if (!this.videoUrl) return '';
        if (this.videoUrl.startsWith('http')) return this.videoUrl;
        return this.videoUrl;
      }
    }
  }
  </script>
  
  <style scoped>
  .video-player {
    width: 100%;
  }
  .video-element {
    width: 100%;
    max-height: 500px;
    border-radius: 8px;
  }
  </style>